export const ADD_CONTEXT_PROPERTY = "ADD_CONTEXT_PROPERTY_TO_RETRIEVE";
export const REMOVE_CONTEXT_PROPERTY = "REMOVE_CONTEXT_PROPERTY_TO_RETRIEVE";
export const SET_CONTEXT_PROPERTIES = "SET_CONTEXT_PROPERTIES_TO_RETRIEVE";
export const UPDATE_CONTEXT_PROPERTY = "UPDATE_CONTEXT_PROPERTY_TO_RETRIEVE";

export function addContextPropertyToRetrieve(contextPropertyToRetrieve) {
    return dispatch => dispatch({
        type: ADD_CONTEXT_PROPERTY,
        contextPropertyToRetrieve
    });
}

export function removeContextPropertyToRetrieve(contextPropertyToRetrieve) {
    return dispatch => dispatch({
        type: REMOVE_CONTEXT_PROPERTY,
        contextPropertyToRetrieve
    });
}

export function setContextPropertiesToRetrieve(contextPropertiesToRetrieve) {
    return dispatch => dispatch({
        type: SET_CONTEXT_PROPERTIES,
        contextPropertiesToRetrieve
    });
}

export function updateContextPropertyToRetrieve(name, property, value) {
    return dispatch => dispatch({
        type: UPDATE_CONTEXT_PROPERTY,
        name,
        property,
        value
    });
}